<app-select [disabled]="disabled()"
  [(ngModel)]="internalModel" (selectedValueChange)="onModelChange($event)">
  @if (allowGreaterThanOrEqual()) {
    <app-option [value]="Comparator.GreaterThanOrEqual" [text]="'≥'">
    </app-option>
  }
  <app-option [value]="Comparator.Equal" [text]="'='">
  </app-option>
  @if (allowLessThanOrEqual()) {
    <app-option [value]="Comparator.LessThanOrEqual" [text]="'≤'">
    </app-option>
  }
</app-select>
